import {postRequest} from "../../src/api/index.js";
import {ENGAGEMENT_INDEX_ERROR, REGISTER, REGISTER_ERROR} from "../../src/actions/types.js";
import {getUser} from "../helpers/index";

export const pageScrollPointReached = async (data, cb) => async (
    dispatch
) => {
    try {
        const user = getUser();
        const res = await postRequest(`/addPageScrollPointReached`, "user", {...data, organizationId: user?.organizationId, orbitId: user?.defaultOrbit ? user?.defaultOrbit : user?.selectedOrbit});

        if (res.status !== 400) {
            cb(res.data);
        } else {
            dispatch({
                type: ENGAGEMENT_INDEX_ERROR,
                payload: res.data.errors[0]
            });
        }
    } catch (err) {
        if (err.response) {
            // There is an error response from the server
            // You can anticipate error.response.data here
            if (err.response.data && err.response.data.errors[0]) {
                dispatch({
                    type: ENGAGEMENT_INDEX_ERROR,
                    payload: err.response.data.errors[0]
                });
            } else {
                const error = err.response.data;
                dispatch({
                    type: ENGAGEMENT_INDEX_ERROR,
                    payload: err.message
                });
            }
        } else if (err.request) {
            // The request was made but no response was received
            // Error details are stored in error.reqeust
            dispatch({
                type: ENGAGEMENT_INDEX_ERROR,
                payload: err.request
            });
        } else if (err) {
            dispatch({
                type: ENGAGEMENT_INDEX_ERROR,
                payload: err.message
            });
        } else {
            // Some other errors
            dispatch({
                type: ENGAGEMENT_INDEX_ERROR,
                payload: "Something went wrong."
            });
        }
    }
};
